export default __webpack_public_path__ + "static/media/address.4b23e9d5.png";